import React from "react";
import { useDrop } from "react-dnd";
import { MayaOrigin } from "../components/Maya";
import basket from "../images/basket.png";
import corn from "../images/corn.png";
import "./Box.css";


const mayaImages = [corn, basket];

/* 
This component implements a box into which Maya images can be dropped.
Parts of it were created with the help of LLMs.
*/
function MayaBoxOrigin({ id, droppedItems, onDropItem, itemSize }) {
  const [, drop] = useDrop({
    accept: "maya-destination",
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDropItem(item.id, id); // item.id is 2d-array. item[0] is index of item that was dropped, that index corresponds to a char (e.g. in Roman 2 = 'X'). id is the index of the box it was dropped in.
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });

  const mayaStyle = {
    height: itemSize+"dvh",
    display: "flex",
    justifyContent: "center",
    zIndex: 1,
    marginLeft: "2dvh",
    marginRight: "2dvh",
    marginBottom: "1dvh",
  };

  const boxStyle = {
    display: "flex",
    flexDirection: "row",
    width: "70dvh",
    height: "40dvh",
    zIndex: 0,
    borderRadius: "0.25em",
    justifyContent: "center",
  };

  const dropStyle = {
    maxWidth: boxStyle.width,
    maxHeight: boxStyle.height,
    backgroundColor: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "center",
  };

  return (
    <div ref={drop} style={dropStyle}>
      <div alt="MayaBox" style={boxStyle}>
        <React.Fragment key={id}>
          <div style={{display: "flex", alignItems: "center"}}>
            {/* Render Maya corn object only if less than 4 corn have been dropped. */}
            {droppedItems[0] < 4 && <span style={mayaStyle}><MayaOrigin id={[0, 0]} mayaImage={mayaImages[0]} isCorn={true} itemSize={itemSize}/></span>}
            {droppedItems[0] === 4 && <span key={[0, id]}><img src={mayaImages[0]} alt="maya-image" style={{...mayaStyle, opacity: "0.3"}}/></span>}

            {/* Render Maya basket object only if less than 3 baskets have been dropped. */}
            {droppedItems[1] < 3 && <span style={mayaStyle}><MayaOrigin id={[1, 0]} mayaImage={mayaImages[1]} isCorn={false} itemSize={itemSize}/></span>} 
            {droppedItems[1] === 3 && <span key={[1, id]}><img style={{...mayaStyle, width: (4*itemSize)+"dvh", opacity: "0.3"}} src={mayaImages[1]} alt="maya-image"/></span>}
          </div>
        </React.Fragment>
      </div>
    </div>
  );
}

export default MayaBoxOrigin;
